import { useEffect, useState } from 'react'

import { useOrulAuthContext } from '@rhaimes/react'
import styled from 'styled-components'


import { Spinner } from 'core/components'

export default function AuthCallback() {
  const { client } = useOrulAuthContext()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Extrair slug da loja ANTES de processar callback
        const urlParams = new URLSearchParams(window.location.search)
        const lojaSlug = urlParams.get('loja')
        
        // Remover originalUrl do state para evitar redirect do SDK
        const params = new URLSearchParams(window.location.search)
        const stateParam = params.get('state')

        if (stateParam) {
          try {
            const stateData = JSON.parse(atob(stateParam))
            // Remover originalUrl do state
            delete stateData.originalUrl
            // Recodificar state sem originalUrl
            const newStateParam = btoa(JSON.stringify(stateData))
            params.set('state', newStateParam)

            // Atualizar URL sem reload
            const newUrl = `${window.location.pathname}?${params.toString()}`
            window.history.replaceState({}, '', newUrl)
          } catch (e) {
            // Se falhar ao manipular state, continua normalmente
          }
        }

        // Chamar handleCallback do SDK
        await client.handleCallback()

        // Disparar evento customizado para notificar o OrulAuthProvider
        // O handleCallback() salvou os tokens no storage
        window.dispatchEvent(new CustomEvent('orul-auth-tokens-changed'))

        // Aguardar um pouco para o AuthProvider processar os tokens e carregar user data
        // Depois navegar para o app
        setTimeout(() => {
          const targetUrl = lojaSlug ? `/${lojaSlug}` : '/'
          
          // Substituir a entrada atual do histórico pela página de destino
          // Isso remove a página de callback do histórico sem causar navegações extras
          window.location.replace(targetUrl)
        }, 500)
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : 'Erro no callback'
        setError(errorMessage)
        setTimeout(() => {
          window.location.replace('/')
        }, 3000)
      }
    }

    handleCallback()
  }, [client])

  if (error) {
    return (
      <Container>
        <ErrorContent>
          <ErrorTitle>Erro na Autenticação</ErrorTitle>
          <ErrorMessage>{error}</ErrorMessage>
          <ErrorSubtext>Redirecionando...</ErrorSubtext>
        </ErrorContent>
      </Container>
    )
  }

  return (
    <Container>
      <Content>
        <Spinner />
        <Message>Processando autenticação...</Message>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
`

const Content = styled.div`
  text-align: center;
`

const Message = styled.p`
  margin-top: 1rem;
  font-size: 0.875rem;
  color: #64748b;
`

const ErrorContent = styled.div`
  text-align: center;
  max-width: 400px;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`

const ErrorTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: 600;
  color: #ef4444;
  margin-bottom: 0.5rem;
`

const ErrorMessage = styled.p`
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 1rem;
`

const ErrorSubtext = styled.p`
  font-size: 0.75rem;
  color: #94a3b8;
`
